import React  from 'react';
import { CROSS } from '../../constants/urls';
import {
  BottomDrawContainer,
  BottomDrawClose,
  DrawerOverlay,
  CLoseButton,
  DrawHeader,
  DrawerContent,
  HeaderLine,
  HeaderText
} from './styles';

interface Props {
  isOpen: boolean;
  closeBottomDraw: () => void;
  content: any;
  drawHeight: number;
  title:string;
  logout:boolean;
}
const BottomDraw: React.FC<Props> = ({
  isOpen,
  closeBottomDraw,
  content,
  drawHeight,
  title,
  logout,
}) => (
    <>
      <BottomDrawContainer 
      isDrawOpen={isOpen} 
      height={drawHeight} 
      logout={logout}
      >
        <BottomDrawClose>
          <CLoseButton
           onClick={closeBottomDraw}>
            <img
              src={CROSS}
              alt=""
              width="48px"
              height="48px"
            />
          </CLoseButton>
        </BottomDrawClose>
        <DrawHeader>
            <HeaderLine/>
            <HeaderText>{title}</HeaderText>
        </DrawHeader>
        <DrawerContent>{content}</DrawerContent>
      </BottomDrawContainer>
      {isOpen && <DrawerOverlay zIndex={200}/>}
    </>
  );

export default BottomDraw;
